import { Maintenance } from '@/app/maintenance/entities/maintenance.entity'

export interface MaintenanceState {
    maintenance?: Maintenance
}

export const state: MaintenanceState = {
    maintenance: undefined
}
